import { render, staticRenderFns } from "./VerifyMemberFacePage.vue?vue&type=template&id=1ed23cbd"
import script from "./VerifyMemberFacePage.vue?vue&type=script&lang=js"
export * from "./VerifyMemberFacePage.vue?vue&type=script&lang=js"
import style0 from "./VerifyMemberFacePage.vue?vue&type=style&index=0&id=1ed23cbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports